import { Form } from 'factorial-form'
import { ContractsEmployeesReferenceContractFragment } from 'generated/resources/graphql'

import { jobTitleField, salaryFields } from 'modules/contracts/lib/checkFieldVisibility'

const contractVersionToFormValues = (
  contractVersion: ContractsEmployeesReferenceContractFragment
) => {
  return {
    id: contractVersion?.id,
    effective_on: null,
    es_job_description: contractVersion.esJobDescription,
    job_catalog_level_id: contractVersion.jobCatalogLevel?.id,
    job_catalog_role_id: contractVersion.jobCatalogLevel?.role?.id,
    job_catalog_tree_node_uuid: contractVersion.jobCatalogTreeNodeUuid,
    job_title: contractVersion.jobTitle,
    salary_amount: contractVersion ? Number(contractVersion.salaryAmount) : null,
    salary_frequency: contractVersion.salaryFrequency,
    payroll_policy_id: contractVersion.payrollPolicy?.policy?.id,
    de_base_salary_type_id: contractVersion.deBaseSalaryTypeId ?? undefined,
  }
}

export const getPromoteFlowForm = (
  contractVersion: ContractsEmployeesReferenceContractFragment
): Form => {
  const canSeeJobTitle = contractVersion._policies?.seeJobTitle.can ?? false
  const canSeeGrossSalary = contractVersion._policies?.seeGrossSalary.can ?? false

  return new Form(
    {
      ...contractVersionToFormValues(contractVersion),
    },
    {
      ...jobTitleField(canSeeJobTitle),
      id: 'number',
      effective_on: 'date',
      es_job_description: 'string',
      job_catalog_level_id: 'number',
      job_catalog_role_id: 'number',
      job_catalog_tree_node_uuid: 'string',
      job_catalog_role_level_name: 'string',
      payroll_policy_id: 'number',
      de_base_salary_type_id: 'number',
      ...salaryFields(canSeeGrossSalary),
    }
  )
}
